import axios from "axios";
import React, { useState } from "react";
import urls from "../urls";
import { useSelector } from "react-redux";

const AddNewInventoryItem = ({ onNewItem }) => {
  const [inventoryCode, setInventoryCode] = useState("");
  const [itemName, setItemName] = useState("");
  const [itemUsePlace, setItemUsePlace] = useState("");
  const [errors, setErrors] = useState({});
  const [disableSubmit, setDisableSubmit] = useState(true);
  const faculty_id = useSelector((state) => state.userState.faculty_id);

  // Validate inputs
  const validateInputs = () => {
    const newErrors = {};
    if (inventoryCode.trim() === "") {
      newErrors.inventoryCode = "رقم الجرد مطلوب";
    }
    if (itemName.trim() === "") {
      newErrors.itemName = "اسم المادة مطلوب";
    }
    // if (itemUsePlace.trim() === "") {
    //   newErrors.itemUsePlace = "مكان استغلالها مطلوب";
    // }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  const checkForValidInventoryCode = (i) => {
    const newErrors = {};
    const inventoryCode = i.target.value;
    axios
      .post(urls.checkInventoryCode, {
        inventoryCode,
        faculty_id,
      })
      .then((res) => {
        const { not_valid } = res.data;
        if (not_valid) {
          newErrors.inventoryCode = "رقم الجرد موجود مسبقا يرجي تغييره ";
          setErrors(newErrors);
          setDisableSubmit(true);
        } else {
          setDisableSubmit(false);
          setErrors({});
        }
      })
      .catch((err) => console.log(err));
  };
  // Handle form submission
  const handleSubmit = () => {
    if (validateInputs()) {
      const newItem = {
        inventoryCode,
        itemName,
        // itemUsePlace,
      };
      onNewItem(newItem); // Pass data to parent
      setInventoryCode(""); // Clear inputs
      setItemName("");
      setItemUsePlace("");
      setErrors({}); // Clear errors
    }
  };

  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (disableSubmit) return;
      handleSubmit();
    }
  };

  return (
    <div className="container mt-2">
      <div className=" ">
        {/* رقم الجرد Input */}
        <div className="mb-3">
          <label htmlFor="inventoryCode" className="form-label">
            رقم الجرد
          </label>
          <input
            type="text"
            className={`form-control ${
              errors.inventoryCode ? "is-invalid" : ""
            }`}
            id="inventoryCode"
            value={inventoryCode}
            onChange={(e) => setInventoryCode(e.target.value)}
            onKeyDown={handleKeyPress}
            onBlur={checkForValidInventoryCode}
          />
          {errors.inventoryCode && (
            <div className="invalid-feedback">{errors.inventoryCode}</div>
          )}
        </div>

        {/* اسم المادة Input */}
        <div className="mb-3">
          <label htmlFor="itemName" className="form-label">
            اسم المادة أو وصفها
          </label>
          <textarea
            className={`form-control ${errors.itemName ? "is-invalid" : ""}`}
            id="itemName"
            value={itemName}
            onChange={(e) => setItemName(e.target.value)}
            onKeyDown={handleKeyPress}
          ></textarea>
          {/* <input
            type="te"
            className={`form-control ${errors.itemName ? "is-invalid" : ""}`}
            id="itemName"
            value={itemName}
            onChange={(e) => setItemName(e.target.value)}
            onKeyDown={handleKeyPress}
          /> */}
          {errors.itemName && (
            <div className="invalid-feedback">{errors.itemName}</div>
          )}
        </div>

        {/* مكان استغلالها Input */}
        {/* <div className="col-md-3">
          <label htmlFor="itemUsePlace" className="form-label">
            مكان استغلالها
          </label>
          <input
            type="text"
            className={`form-control ${
              errors.itemUsePlace ? "is-invalid" : ""
            }`}
            id="itemUsePlace"
            value={itemUsePlace}
            onChange={(e) => setItemUsePlace(e.target.value)}
            onKeyDown={handleKeyPress}
          />
          {errors.itemUsePlace && (
            <div className="invalid-feedback">{errors.itemUsePlace}</div>
          )}
        </div> */}

        {/* إضافة Button */}
        <div className=" d-flex justify-content-end   ">
          <button
            className="btn btn-primary"
            style={{ width: "150px" }}
            onClick={handleSubmit}
            disabled={disableSubmit}
          >
            إضافة
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddNewInventoryItem;
